import {call, put} from 'redux-saga/effects';
import {
    getDeliveryManagerManifest,
    getDeliveryManagerManifestJson,
} from '@pluto/rest';
import {setNotificationError} from '@pluto/notification';
import {Action} from 'redux-actions';
import {setDeliveryManagerManifestAction} from '../DeliveryManagerManifestAction';

export interface DeliveryManagerManifestWorkerPayload {
    id: string
}

export function* fetchDeliveryManagerManifestWorker({payload}: Action<DeliveryManagerManifestWorkerPayload>) {
    try {
        const {id} = payload;

        const {url} = yield call(getDeliveryManagerManifest, id);
        const jsonManifest = yield call(getDeliveryManagerManifestJson, url);
        const jsonData = JSON.stringify(jsonManifest);

        yield put(setDeliveryManagerManifestAction({
            url: jsonData,
        }));
    } catch(error) {
        yield put(setNotificationError(error.message));
    }
}
